export default __webpack_public_path__ + "static/media/facebook.75640737.svg";